<!--Project map widget (synthesis)-->
<div class="project-map-content" [class.bare]="bare" #htmlContent>
  @if (isLoading()) {
    <app-widget-loading [graphType]="widget?.graphType"></app-widget-loading>
  } @else {
    @if (showTitle) {
      @if (richTitle && showTitle) {
<app-widget-title class="flush" [title]="title" [design]="widget?.design?.title"></app-widget-title>
} @else {
<p class="project-map-title" [style]="titleStyle">{{ title }}</p>
}
    }

    @if (error) {
      <span class="error">{{ error }}</span>
    }

    <div class="project-map-container">
      <google-map appMapTheme [options]="mapOptions" width="100%" height="100%" (mapInitialized)="fit()">
        @for (bubble of bubbles; track bubble.pid) {
          <map-marker [position]="{ lat: bubble.lat, lng: bubble.lng }" [options]="markerOptions[bubble.pid]!"
            (mapMouseover)="hover(bubble, $event)" (mapMouseout)="hovered = null"></map-marker>
        }
      </google-map>

      @if (hovered) {
        <lib-tooltip [x]="hovered.x" [y]="hovered.y">
          <strong>{{ hovered.bubble.name }}</strong>
          @if (hovered.bubble.city) {
            <span class="tooltip-detail">{{ hovered.bubble.city }}</span>
          }
          <span class="tooltip-value">{{ hovered.bubble.value | number }}</span>
        </lib-tooltip>
      }
    </div>

    @if (showLegend) {
      <div class="project-map-legend">
        @for (item of legend; track item.tone) {
          <span class="legend-item">
            <span class="legend-dot" [class.theme-dot]="!colors[item.tone]" [style.background]="colors[item.tone]"></span>
            {{ 'editor.project_map_tone_' + item.tone | translate }} ({{ item.bound }})
          </span>
        }
        <span class="legend-size">{{ 'editor.project_map_legend_size' | translate }}</span>
      </div>
    }

    @if (missing.length) {
      <p class="project-map-missing">{{ 'editor.project_map_missing' | translate: { names: missing.join(', ') } }}</p>
    }
  }

  @if (widgetRendered && !isLoading()) {
    <div id="chart-rendered"></div>
  }
</div>
